<template>
  <div class="container" style="text-align: center">
    <div class="row my-5 py-3">
      <div class="col-lg-8 offset-2">
        <div class="form-signin">
          <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>

          <div class="form-group">
            <input id="firstName" v-model="first_name" class="form-control" placeholder="First Name" required
                   type="text">
          </div>

          <div class="form-group">
            <input id="lastName" v-model="last_name" class="form-control" placeholder="Last Name" required type="text">
          </div>

          <div class="form-group">

            <input id="inputEmail" v-model="email" autofocus class="form-control" placeholder="Email address"
                   required type="email">
          </div>
          <div class="form-group">

            <input id="inputPassword" v-model="password" class="form-control" placeholder="Password" required
                   type="password">
          </div>
          <div class="form-group">

            <input id="inputPassword2" v-model="password2" class="form-control" placeholder="Confirm Password"
                   required type="password">
          </div>


          <div class="checkbox mb-3">
            <label>
              <input type="checkbox" value="remember-me"> Remember me
            </label>
          </div>
          <span class="btn btn-lg btn-primary btn-block" @click="doRegister">Sign in</span>
          <p class="mt-5 mb-3 text-muted">&copy; 2017-2020</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data() {
    return {
      email: "",
      password: "",
      password2: "",
      first_name: "",
      last_name: ""
    }
  },
  methods: {
    doRegister() {
      if (this.password !== this.password2 || this.email === '' || this.password === '' || this.password2 === '') {
        return false
      }


      this.$store.dispatch('postRegister', {
        email: this.email,
        password: this.password,
        first_name: this.first_name,
        last_name: this.last_name
      })
          .then(response => {
            this.$router.push('/')
          })
    }
  }
}
</script>

<style>
</style>
